// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

class Hour extends Component {

  static propTypes = {
    value: PropTypes.number.isRequired,

    onChange: PropTypes.func.isRequired,

    isSelected: PropTypes.bool
  };

  onChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onChange(this.props.value);
  };

  render() {
    const className = classNames('col-xs-3', 'hour_chooser__hour', {
      selected: this.props.isSelected
    });

    return (
      <div
        className={className}
        onClick={this.onChange}
      >
        {this.props.value}
      </div>
    );
  }

}

export default Hour;
